module.exports = "/images/moped.svg";